export enum UserState {
  Invited = 'Invited',
  Pending = 'Pending',
  Active = 'Active',
  Blocked = 'Blocked',
  Deleted = 'Deleted',
}
